import { Box, Container, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import axios from 'axios';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Divider } from 'semantic-ui-react';
import { API_URL, APP_URL } from '../../Config';
import LikeButton from '../Like/likebutton';


const MembershipNFT =  () => {
    const [nftdata,Setdata]=useState('');
    
    const fetchdata=async()=>{
        await axios.get(`${API_URL}/FetchmemberNFT.php`, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((result)=>{
           Setdata(result.data)
          })

        
    }
    useEffect(()=>{
        fetchdata();
    },[])

    return (
        <div>
            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        Membership NFT
                    </Typography>
                </Box>
            </Box>


            <Box className="collection_details">
                <Container maxWidth='xl'>
                    <Grid container spacing={1}>
                    {nftdata && nftdata.map((token, idx) => (
                            <Grid key={idx} item lg={3} sm={6} md={4} xs={12} marginBottom='30px'>
                            <Box className='ContenMain'>

                            <Link to={`/Buydetails/${token.NFT_id}`}>
                             {token.NFT_image.split('.').pop()== "png" ||token.NFT_image.split('.').pop()=='jpg'||token.NFT_image.split('.').pop()=='jpeg'?
                                <img src={APP_URL+'/'+token.NFT_image} width='100%' className='base_pht' style={{ borderRadius: '5px' }} /> 
                                :token.NFT_image.split('.').pop()== "mp4" ?
                                <video width="750" height="500" controls >
                                    <source src={APP_URL+'/'+token.NFT_image} type="video/mp4"/>
                                </video>
                                :token.NFT_image.split('.').pop()== "mp3" ||token.NFT_image.split('.').pop()=='aac'?
                                <audio controls>
                                <source src={APP_URL+'/'+token.NFT_image} type="audio/mpeg"/>
                                Your browser does not support the audio tag.
                                </audio> 
                                :<img src={APP_URL+'/'+token.NFT_image} width='100%' className='base_pht' style={{ borderRadius: '5px' }} />
                                } 
                            </Link>
                               <Box display='flex' justifyContent='space-between' paddingY='10px'>
                                    <Box>
                                        <Typography fontWeight='600' fontSize='22' variant='h6' color='#000'>
                                            {token.NFT_name}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <LikeButton nft={token} />
                                    </Box>
                                </Box>
                                <Divider />
                                <Box>
                                    <Box>
                                        <Typography variant='h5' color='#000' fontWeight='600' fontSize='16px'>
                                            Reserve Price
                                        </Typography>
                                        <Typography fontWeight='500' variant='h6' fontSize='15px' color='#000'>
                                            {token.NFT_price} {token.NFT_payment}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        ))}
                     
                    </Grid>
                </Container>
            </Box>
        </div>
    )
}

export default MembershipNFT;